/**
* Created by kongwm.kong on 2017/7/21.
*/
<template>
    <div class="layout_n">
        <div class="message-page-wrap">
            <div class="title">全部消息</div>
            <div class="msg_wrap">
                <table class="msg_table">
                    <thead>
                        <tr class="fist tr_item clearfix">
                            <td class="td1"><div class="check-wrap" @click="showCheck(1, $event)"><input type="checkbox" class="che-hide"></div></td>
                            <td class="td2">消息内容</td>
                            <td class="td3">消息日期</td>
                            <td class="td4">消息类型</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in msgList" class=" tr_item clearfix" :data-id="item.id">
                            <td class="td1"><div class="check-wrap" @click="showCheck(0, $event)"><input type="checkbox" class="che-hide"></div></td>
                            <td class="td2 "  @click="showItem"><span v-show="item.readed ==0" class="dian"></span><span class="span-html ellipsis">{{item.msgContent}}</span></td>
                            <td class="td3" @click="showItem">{{item.createTime  | setTime('yyyy-mm-dd')}}</td>
                            <td class="td4" @click="showItem">{{item.msgType | getMsgType}}</td>
                        </tr>
                    </tbody>
                </table>
                <!--<div class="msg_table">-->
                    <!--<div class="fist tr_item clearfix">-->
                        <!--<div class="td1"><div class="check-wrap"><input type="checkbox" class="che-hide"></div></div>-->
                        <!--<div class="td2">消息内容</div>-->
                        <!--<div class="td3">消息日期</div>-->
                        <!--<div class="td4">消息类型</div>-->
                    <!--</div>-->
                    <!--<div class="tr_item clearfix">-->
                        <!--<div class="td1"><div class="check-wrap"><input type="checkbox" class="che-hide"></div></div>-->
                        <!--<div class="td2"><span class="dian"></span>尊敬的用户您好！您2017年01月17日提交的承诺函信息已经通过审核</div>-->
                        <!--<div class="td3">2017-01-17 17:30:21</div>-->
                        <!--<div class="td4">注册信息</div>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
            <div class="btn_wrap">
                <button class="btn btn-def" @click="readed">标记已读</button>
                <button class="btn btn-def" @click="allReaded">全部已读</button>
            </div>
            <div class="page_wrap" v-show="pageShow">
                <paginate
                        :pageCount="pageCount"
                        :containerClass="'pagination'"
                        :clickHandler="changePage"
                        :pageRange="3"
                        :marginPages="1"
                        :prevText="'&lt;'"
                        :nextText="'&gt;'"
                        :pageClass="'page-item'"
                ></paginate>
            </div>
        </div>
    </div>

</template>
<script>
    import Paginate from 'vuejs-paginate'
  export default {
      components:{
          Paginate
      },
      data (){
          return {
              pageShow: false,
              curPage: 1,
              pageSize: 10,
              msgList: [],
              pageCount: 0,
          }
      },
      mounted(){
          this.getMsgList();
      },
      methods:{
          getMsgList(){
            this.$http.request({
                url: `/innerMsg/page?pageNo=${this.curPage}&pageSize=${this.pageSize}`
            }, response => {
                if(response.data.code == 200){
                    this.msgList = response.data.data.list;
                    this.pageCount = Math.ceil(response.data.data.total/this.pageSize);
                    if(this.pageCount <2) {
                        this.pageShow = false;
                    } else {
                        this.pageShow = true;
                    }
//                    this.pageShow =  (this.pageCount < 2) ? false : true;
                }
            }, err => {

            })
          },
          showItem(e){
              let dom  = $(e.target).closest('.tr_item');
              dom.find('.td2 .span-html').toggleClass('ellipsis');
              dom.siblings('.tr_item').find('.td2 .span-html').addClass('ellipsis');
              this.readed(dom.data('id'));
          },
          showCheck(flag, e){
              e.preventDefault();
              let dom = $(e.target).closest('.check-wrap');
              if(flag ==1){
                  if(dom.hasClass('active')){
                      $('.msg_table').find('.check-wrap').removeClass('active');
                  } else {
                      $('.msg_table').find('.check-wrap').addClass('active');
                  }
              } else {
                  dom.toggleClass('active');
                  let parDom = dom.closest('.msg_table');
                  if(parDom.find('tbody').find('.check-wrap.active').length == parDom.find('tbody').find('.check-wrap').length){
                      $('.msg_table').find('thead').find('.check-wrap').addClass('active');
                  } else {
                      $('.msg_table').find('thead').find('.check-wrap').removeClass('active');
                  }
              }

          },
          readed(id){
              let idStr;
              if(typeof id === 'number'){
                  idStr  = id;
              } else {
                  let idArr = [];
                  let dom = $('.msg_table tbody .tr_item').find('.check-wrap.active');
                  dom.each(function(index, el){
                      let idi = $(el).closest('.tr_item').data('id');
                      if(idi){
                          idArr.push(idi);
                      }
                  });
                  idStr = idArr.join(',');
              }
              if(idStr == "" || !idStr){
                  return false;
              }
              this.$http.request({
                  url: `/innerMsg/selectReaded`,
                  method: 'put',
                  headers: {'Content-Type': 'application/json'},
                  data: idStr
              },response => {
                  if(response.data.code === 200 && response.data.data === true){
                      if(typeof id === 'number'){
                          $('.msg_table tbody .tr_item[data-id='+id+']').find('.dian').removeClass('dian');
                      } else {
                          $('.msg_table tbody .tr_item .check-wrap.active').closest('.tr_item').find('.dian').removeClass('dian');
                      }
                      if($('.msg_table tbody .tr_item .dian').length == 0){
                          this.$store.commit('setMsgNum', 0);
                      }
                  }
              }, err => {

              });
          },
          allReaded(){
              this.$http.request({
                  url: `/innerMsg/allReaded`,
                  method: 'put'
              },response => {
                if(response.data.code === 200 && response.data.data === true){
                    this.$store.commit('setMsgNum', 0);
                    this.msgList.forEach(function(el, index, arr){
                        el.readed = 1;
                    });
                }
              }, err => {

              });
          },
          changePage(page){
              if( this.curPage != page){
                  $('.msg_table').find('.check-wrap').removeClass('active');
                  this.curPage = page;
                  this.getMsgList();
              }

          },
      },
      created(){
          this.$store.commit('getLoginData');
      },
  }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/center";
    .layout_n{
        @include mainMar;
    }
    .message-page-wrap{
        @include bgff;
        padding: 50px 38px 170px;
        .title{
            @include subTitle;
        }
        .page_wrap{
            text-align: right;
        }
        .msg_table{
            width:100%;
            font-size:16px;
            .tr_item{
                &.fist{
                    background: #F4F8FF;
                    border-bottom:0;
                }
               // padding:0 26px;
                border-bottom: 1px solid #E9EBFF;
                color: $c_989;
                line-height: 2;
                letter-spacing: -0.39px;
                &:nth-child(even){
                    color:$c_666;
                    background: #F4F8FF;
                }
            }
            .td1,.td2,.td3,.td4{
                padding:22px 0;
            }
            .td1{
                width:16px;
                margin-right:14px;
                .check-wrap{
                    width:100%;
                    height:16px;
                    //border: 1px solid $border_bfb;
                    background: url(../../assets/img/common/check.png) no-repeat center center;
                    border-radius: 4px;
                    position: relative;
                    &.active{
                        background-image: url(../../assets/img/common/checked.png);
                    }
                    .che-hide{
                        opacity: 0;
                        position: absolute;
                        left: 0;
                        right:0;
                        top:0;
                        bottom: 0;
                    }
                }

            }
            .td2{
                width:810px;
                margin-right:20px;
                text-indent: 17px;
                .dian{
                    display: inline-block;
                    width:8px;
                    height:8px;
                    background: $btn_408;
                    border-radius: 50%;
                    margin-right: 10px;
                    &.hide{
                        background: transparent;
                    }
                }
                .span-html{
                    display: inline-block;
                    width:740px;
                    vertical-align: middle;
                    text-indent: 0;
                }
            }
            .td3{
                width:155px;
                margin-right:20px;
                text-align: center;
            }
            .td4{
                width:100px;
                text-align: right;
            }
        }
        /*按钮*/
        .btn_wrap{
            margin-top:50px;
            padding-left:20px;
            .btn{
                width:120px;
                height:40px;
                border:1px solid $border_bfb;
                text-align: center;
                line-height: 40px;
                background: transparent;
                font-size: 16px;
                color: $c_989;
                letter-spacing: -0.39px;
                font-weight:bold;
                float: left;
                cursor: pointer;
                &:hover{
                    background: $btn_408;
                    border-color:$btn_408;
                    color:#fff;
                }
                &:active{
                    background: $btn_ffa;
                    border-color:$btn_ffa;
                    color:#fff;
                }
                &+.btn{
                    margin-left:10px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/user/message.vue